import { Component } from '@angular/core';
import { NavController, IonicPage, NavParams, ToastController } from 'ionic-angular';
import { Socket } from 'ng-socket-io';
import { Observable } from 'rxjs/Observable';
import { Storage } from '@ionic/storage'

@IonicPage()
@Component({
  selector: 'page-chat',
  templateUrl: 'chat.html',
})
export class ChatPage {
  messages = [];
  usuario = '';
  message = '';
 
  constructor(private navCtrl: NavController, private navParams: NavParams, private socket: Socket, private toastCtrl: ToastController,
             public storages:Storage) {
               this.storages.get('nombreUsuario').then((val)=>{
                 this.usuario = val
               })
    // this.socket.connect();
    // this.getMessages().subscribe(message => {
    //   this.messages = []
    //   if(message!=null){
    //     if(message[0][0]!=undefined){
    //       this.messages = message[0]
    //     }else{
    //         this.messages.push(message)
    //     }
    //    if(this.messages[0][0]!=undefined){
    //       this.messages = this.messages[0]
    //     }
        
    //   }
      
    // });
 

  }
 
  sendMessage() {
    if(this.usuario==''){
      this.usuario = 'Anónimo'
    }
    this.socket.emit('new-message', { text: this.message ,author:this.usuario});
    this.message = '';
  }
 
  getMessages() {
    let observable = new Observable(observer => {
      this.socket.on('messages', (data) => {
        observer.next(data);
      });
    })
    return observable;
  }
  
  ionViewWillLeave() {
    this.socket.disconnect();
  }
 
  showToast(msg) {
    let toast = this.toastCtrl.create({
      message: msg,
      duration: 2000
    });
    toast.present();
  }
graficas(){
  this.navCtrl.push('GraficasPage');
}
}



// WEBPACK FOOTER //
// ./src/pages/chat/chat.ts